import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {ContactPersonModel} from "../../../../commons/models/contact-person.model";
import {
  CONTACT_PERSONS_TABLE_COLUMN_WIDTHS,
  CONTACT_PERSONS_TABLE_ROW_HEIGHT,
  CONTACT_PERSONS_TABLE_UNIQUE_ID
} from "../../constants/contact-persons-table.constant";

export interface ContactPersonsTableItem {
  id: string;
  branchName: string;
  contact: ContactPersonModel;
}

require('./contact-persons-table.scss');
@Component({
  standalone: false,
  selector: 'app-contact-persons-table',
  templateUrl: './contact-persons-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactPersonsTableComponent {

  @Input() items: ContactPersonsTableItem[] = [];
  @Input() isLoading: boolean;
  @Output() onDelete = new EventEmitter<string>();

  public readonly tableUniqueId: string = CONTACT_PERSONS_TABLE_UNIQUE_ID;
  public readonly defaultWidths: { [key: string]: number } = CONTACT_PERSONS_TABLE_COLUMN_WIDTHS;
  public readonly rowHeight: number = CONTACT_PERSONS_TABLE_ROW_HEIGHT;

}
